<template>
  <div class="layout-container">
    <Header></Header>
    <AppMain></AppMain>
    <Footer></Footer>
    <PrivacyPolicyPopup v-if="$store.getters.agreements.length>0" ref="policyPopup"></PrivacyPolicyPopup>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import AppMain from './components/AppMain'
import PrivacyPolicyPopup from '@/components/PrivacyPolicyPopup'

export default {
  name: 'Layout',
  components: {
    Header,
    Footer,
    AppMain,
    PrivacyPolicyPopup
  },
  data() {
    return {

    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

</style>
